import React from 'react';
import TextBox from 'components/TextBox';
import TestDragAndDrop from 'components/DragAndDrop/Audits';
import i18n from 'constants/translation/i18n';

const auditFindingColumns = (
  pageSize = 2,
  totalRows = 0,
  paginatedData: { key: number; id: string; text: string }[] = []
) => {
  const rowSpanCount = pageSize;
  const auditFindingColumn = [
    {
      title: i18n.t('NOT_ALIGNED_AUDIT_FINDINGS'),
      dataIndex: 'notAlignedAudit',
      key: 'notAlignedAudit',
      render: (
        notAlignedAudit: string,
        record: { key: number; id: string; text: string },
        index: number
      ) => {
        if (index === 0) {
          return (
            <TextBox>
              <TestDragAndDrop paginatedData={paginatedData} />
            </TextBox>
          );
        }
        if (index < rowSpanCount) {
          return null;
        }
        return <div>{notAlignedAudit}</div>;
      },
      onCell: (
        record: { key: number; id: string; text: string },
        index: number
      ) => ({
        rowSpan: index === 0 ? rowSpanCount : 1
      })
    }
  ];
  return auditFindingColumn;
};

const auditFindingsMockedData = [
  {
    key: 1
  }
];

export { auditFindingColumns, auditFindingsMockedData };
